var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup344(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 423.181,
    height: 109.258,
    viewBox: "0 0 423.181 109.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -64.351,
    y1: -48.312,
    x2: 544.065,
    y2: 409.63,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -53.897,
    y1: -41.334,
    x2: 449.633,
    y2: 345.896,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.415,
    y1: 0.451,
    x2: 1.544,
    y2: 0.556,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.591,
    y1: 0.452,
    x2: 1.685,
    y2: 0.552,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.544,
    y1: 0.444,
    x2: 1.415,
    y2: 0.549,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.685,
    y1: 0.448,
    x2: 1.591,
    y2: 0.548,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.892,
    gradientTransform: "translate(1.937 0.4) scale(0.441 0.903)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f225b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#66c9d7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.821,
    gradientTransform: "translate(1.845 0) scale(0.477 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#66c9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f225b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 1.522,
    cy: -0.579,
    r: 3.549,
    gradientTransform: "translate(1.547 -0.037) scale(0.82 1.018)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 4.935,
    cy: -0.632,
    r: 4.016,
    gradientTransform: "translate(-17.916 -0.039) scale(1.817 1.018)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 5.346,
    cy: -2.204,
    r: 15.915,
    gradientTransform: "translate(10.496 -0.159) scale(0.634 1.018)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 1.149,
    cy: -0.456,
    r: 3.279,
    gradientTransform: "translate(-15.384 -0.035) scale(1.931 1.018)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 3.511,
    cy: -13.375,
    r: 34.259,
    gradientTransform: "translate(22.351 -0.221) scale(0.402 1.018)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.511,
    cy: -0.723,
    r: 2.016,
    gradientTransform: "translate(1.295 0) scale(0.794 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 2.322,
    cy: -0.79,
    r: 2.203,
    gradientTransform: "translate(-15.225 0) scale(1.881 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 1.797,
    cy: -2.847,
    r: 8.992,
    gradientTransform: "translate(8.279 0) scale(0.626 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -1.077,
    cy: -0.589,
    r: 1.859,
    gradientTransform: "translate(-10.488 0) scale(1.898 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -1.353,
    cy: -14.763,
    r: 19.4,
    gradientTransform: "translate(15.971 0) scale(0.398 1)",
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(-262.501 -1367.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(262.501 1367.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(148.262 25.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M221.151,219.56a3.928,3.928,0,0,0-5.47,0,3.672,3.672,0,0,0-1.118,2.713v10.172h-.06a19.847,19.847,0,0,0-14.614-4.007,19.913,19.913,0,0,0-7.334,2.437,19.091,19.091,0,0,0-5.86,5.086,20.211,20.211,0,0,0-2.958,5.487,20.655,20.655,0,0,0-1.173,6.1,19.722,19.722,0,0,0,2.192,9.59,19.713,19.713,0,0,0,16.15,10.7,19.96,19.96,0,0,0,10-1.851,20.4,20.4,0,0,0,4.232-2.742,19.9,19.9,0,0,0,3.4-3.669,20.306,20.306,0,0,0,2.376-4.378,19.56,19.56,0,0,0,1.236-4.87c.041-.331.073-.65.092-.959s.032-.624.032-.955v-26.14A3.671,3.671,0,0,0,221.151,219.56Zm-6.77,30.795a12.359,12.359,0,0,1-6.751,8.787q-.617.277-1.217.525.425-.19.851-.4a11.232,11.232,0,0,1-4,.988,13.341,13.341,0,0,1-4.067-.373,11.709,11.709,0,0,1-3.787-1.819,12.4,12.4,0,0,1-2.984-3.051,10.6,10.6,0,0,1-1.755-3.669,12.759,12.759,0,0,1-.4-4.039,11.574,11.574,0,0,1,1.108-4.408,13.19,13.19,0,0,1,2.586-3.669,11.034,11.034,0,0,1,1.691-1.3c.6-.37,1.22-.716,1.879-1.048a11.435,11.435,0,0,1,4.831-1.048,11.86,11.86,0,0,1,4.895,1.048,12.151,12.151,0,0,1,4.039,2.838,11.983,11.983,0,0,1,2.621,4.255A11.814,11.814,0,0,1,214.381,250.355Z",
    transform: "translate(-182.556 -218.451)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M207.861,262.356c-.038.019-.073.035-.112.051-.331.144-.678.277-1.048.4C207.083,262.668,207.469,262.518,207.861,262.356Z",
    transform: "translate(-184.029 -221.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M238.719,231.648a3.893,3.893,0,0,1,3.884,3.885v29.162a3.893,3.893,0,0,1-3.884,3.885,3.638,3.638,0,0,1-2.713-1.141,3.792,3.792,0,0,1-1.11-2.744V235.533a3.794,3.794,0,0,1,1.11-2.744A3.638,3.638,0,0,1,238.719,231.648Z",
    transform: "translate(-185.75 -219.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(66.715 9.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M292.788,244.335a21.346,21.346,0,0,0-1.7-4.624,20.093,20.093,0,0,0-2.748-4.067,19.181,19.181,0,0,0-3.736-3.3,19.98,19.98,0,0,0-19.636-1.541,20.358,20.358,0,0,0-4.229,2.742,19.776,19.776,0,0,0-3.4,3.669,21.168,21.168,0,0,0-2.407,4.41,17.478,17.478,0,0,0-1.2,4.9c-.041.328-.073.646-.093.955s-.032.628-.032.956v26.079a3.671,3.671,0,0,0,1.118,2.713,3.929,3.929,0,0,0,5.471,0,3.674,3.674,0,0,0,1.117-2.713V264.4a21.185,21.185,0,0,0,6.936,3.424,19.255,19.255,0,0,0,7.739.583,19.982,19.982,0,0,0,7.337-2.433,19.147,19.147,0,0,0,5.856-5.086,20.241,20.241,0,0,0,2.959-5.519,20.977,20.977,0,0,0,1.172-6.137A18.8,18.8,0,0,0,292.788,244.335Zm-7.181,5.21a11.443,11.443,0,0,1-1.108,4.347,13.131,13.131,0,0,1-2.586,3.669,11.23,11.23,0,0,1-1.691,1.3q-.893.555-1.879,1.048a11.773,11.773,0,0,1-4.863,1.048,12.331,12.331,0,0,1-11.522-8.076,11.952,11.952,0,0,1-.462-6.414,12.529,12.529,0,0,1,2.806-5.8,10.665,10.665,0,0,1,3.946-2.958,12.284,12.284,0,0,1,1.14-.555l.105-.044c-.293.131-.586.27-.879.414a11.6,11.6,0,0,1,8.067-.554,12.1,12.1,0,0,1,6.77,4.809A11.568,11.568,0,0,1,285.607,249.545Z",
    transform: "translate(-253.607 -228.924)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M271.021,237.422l-.5.206.108-.048C270.762,237.523,270.891,237.475,271.021,237.422Z",
    transform: "translate(-187.924 -219.609)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M271.652,237.163c-.2.075-.4.161-.6.243C271.25,237.325,271.449,237.244,271.652,237.163Z",
    transform: "translate(-187.956 -219.593)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M305.56,231.648a3.9,3.9,0,0,1,3.884,3.885v29.162a3.9,3.9,0,0,1-3.884,3.885,3.639,3.639,0,0,1-2.714-1.141,3.791,3.791,0,0,1-1.109-2.744V235.533a3.793,3.793,0,0,1,1.109-2.744A3.639,3.639,0,0,1,305.56,231.648Z",
    transform: "translate(-189.828 -219.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M361.012,232.7v.984a20.026,20.026,0,0,1-2.436,8.465,19.763,19.763,0,0,1-5.642,6.433,19.933,19.933,0,0,1,5.673,6.515,19.686,19.686,0,0,1,2.4,8.552v1.05a3.793,3.793,0,0,1-3.823,3.828,3.792,3.792,0,0,1-2.744-1.11,3.638,3.638,0,0,1-1.141-2.713v-.617a12,12,0,0,0-1.079-4.469,12.4,12.4,0,0,0-6.2-6.165,11.452,11.452,0,0,0-4.5-1.018.684.684,0,0,1-.308.062.854.854,0,0,1-.37-.062,11.449,11.449,0,0,0-4.5,1.018,12.434,12.434,0,0,0-3.669,2.528,13.059,13.059,0,0,0-2.559,3.638,10.881,10.881,0,0,0-1.048,4.469v.617a3.638,3.638,0,0,1-1.141,2.713,3.793,3.793,0,0,1-2.744,1.11,3.793,3.793,0,0,1-3.823-3.828v-1.05a19.658,19.658,0,0,1,2.4-8.552,19.92,19.92,0,0,1,5.672-6.515,19.765,19.765,0,0,1-5.642-6.433,20.023,20.023,0,0,1-2.436-8.465v-1.046a3.786,3.786,0,0,1,3.823-3.817,3.889,3.889,0,0,1,3.885,3.869v.431a11.025,11.025,0,0,0,1.048,4.484,12.868,12.868,0,0,0,2.559,3.654,11.925,11.925,0,0,0,3.669,2.487,11.8,11.8,0,0,0,4.5.983h.678a11.8,11.8,0,0,0,4.5-.983,11.933,11.933,0,0,0,3.669-2.487,12.389,12.389,0,0,0,2.528-3.654,12.173,12.173,0,0,0,1.079-4.484v-.431a3.854,3.854,0,1,1,7.707-.052Z",
    transform: "translate(-191.026 -219.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(175.422 9.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M407.5,241.1a20.606,20.606,0,0,0-4.223-6.29,18.867,18.867,0,0,0-7.955-4.93,20.15,20.15,0,0,0-9.373-.742,20.879,20.879,0,0,0-6.964,2.621,18.836,18.836,0,0,0-5.552,5.025c-.2.245-.4.5-.586.771s-.36.522-.522.771a19.307,19.307,0,0,0-2.93,9.525,19.868,19.868,0,0,0,2.067,9.774,18.889,18.889,0,0,0,2.9,4.252,19.478,19.478,0,0,0,3.854,3.3,21.26,21.26,0,0,0,4.593,2.252,19.413,19.413,0,0,0,5.057,1.048,3.254,3.254,0,0,0,.646.06h.711a3.592,3.592,0,0,0,2.681-1.108,3.757,3.757,0,0,0,1.077-2.714,3.685,3.685,0,0,0-3.758-3.761h-.249a13.119,13.119,0,0,1-4.5-.987,11.741,11.741,0,0,1-3.452-2.22,12.5,12.5,0,0,1-2.519-3.192c-.064-.124-.13-.254-.193-.385a9.353,9.353,0,0,1-.679-1.542h27.436a4.01,4.01,0,0,0,2.745-1.172,3.861,3.861,0,0,0,1.2-2.71v-.249A18.548,18.548,0,0,0,407.5,241.1Zm-29.872,3.822a12.992,12.992,0,0,1,1.972-3.67,12.575,12.575,0,0,1,3.082-2.866,12.357,12.357,0,0,1,4.688-1.755,11.379,11.379,0,0,1,4.93.277,12.546,12.546,0,0,1,4.471,2.249,11.724,11.724,0,0,1,3.175,3.793,13.242,13.242,0,0,1,.863,1.972Z",
    transform: "translate(-369.377 -228.889)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M438.091,264.707a3.567,3.567,0,0,1-1.079,2.62,4.045,4.045,0,0,1-2.621,1.2h-.555a19.343,19.343,0,0,1-7.521-1.727,20.045,20.045,0,0,1-6.123-4.285,20.375,20.375,0,0,1-4.132-6.227,19.084,19.084,0,0,1-1.522-7.614v-16.03a3.678,3.678,0,0,1,1.118-2.713,3.738,3.738,0,0,1,2.735-1.11,3.837,3.837,0,0,1,2.764,1.11,3.627,3.627,0,0,1,1.151,2.713l-.062,16.03a11.607,11.607,0,0,0,.925,4.625,12.463,12.463,0,0,0,6.2,6.442,11.014,11.014,0,0,0,4.532,1.079h.308a3.895,3.895,0,0,1,3.885,3.884Z",
    transform: "translate(-196.711 -219.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M473.225,256.723a11.486,11.486,0,0,1-.917,4.55,12.113,12.113,0,0,1-2.477,3.751,11.826,11.826,0,0,1-3.707,2.552,11.082,11.082,0,0,1-4.55.953H444.556a3.753,3.753,0,0,1-2.744-1.131,3.819,3.819,0,0,1,0-5.443,3.757,3.757,0,0,1,2.744-1.132h16.893a3.9,3.9,0,0,0,2.868-1.21,3.961,3.961,0,0,0,1.2-2.889,4.034,4.034,0,0,0-1.2-2.95,3.906,3.906,0,0,0-2.868-1.211h-8.015a11.621,11.621,0,0,1-4.623-.925,11.774,11.774,0,0,1-6.288-6.289,12.02,12.02,0,0,1,0-9.248,11.872,11.872,0,0,1,2.528-3.761,12.424,12.424,0,0,1,3.73-2.559,11.082,11.082,0,0,1,4.593-.956H461.2a3.758,3.758,0,0,1,2.744,1.132,3.812,3.812,0,0,1,0,5.444,3.775,3.775,0,0,1-2.754,1.13h-7.86a4.084,4.084,0,0,0-2.847,1.253,4.23,4.23,0,0,0,0,5.85,3.853,3.853,0,0,0,2.9,1.221h8.015a11.315,11.315,0,0,1,4.623.954,12.32,12.32,0,0,1,3.761,2.552,11.811,11.811,0,0,1,2.528,3.751A11.548,11.548,0,0,1,473.225,256.723Z",
    transform: "translate(-198.306 -219.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 7.514,
    height: 6.791,
    transform: "translate(49.242 0.518)",
    fill: "#9add3a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 7.514,
    height: 6.791,
    transform: "translate(112.004 0.518)",
    fill: "#1eafe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M94.975,303.945a11.174,11.174,0,0,0,11.174-11.174V238.785h-.05c-3.168,4.114-7.243,9.459-11.124,14.521Z",
    transform: "translate(-28.95 -194.687)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M96.43,254.026s7.136-9.324,8.441-11.026v50.029a9.823,9.823,0,0,1-8.441,9.712Z",
    transform: "translate(-29.039 -194.944)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M81.994,202.995v53.986h.05c3.167-4.114,7.243-9.459,11.123-14.521V191.821A11.173,11.173,0,0,0,81.994,202.995Z",
    transform: "translate(-28.158 -191.821)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M83.449,203.09a9.823,9.823,0,0,1,8.44-9.713v48.714s-7.119,9.3-8.44,11.027Z",
    transform: "translate(-28.247 -191.916)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M151.188,238.513a28.511,28.511,0,0,0-6.748-9.04,31.9,31.9,0,0,0-10.009-6.095,34.716,34.716,0,0,0-24.514,0,31.91,31.91,0,0,0-10.01,6.095c-1.241,1.121-6.534,7.3-12.27,14.057-3.881,4.573-7.956,9.4-11.124,13.117-2.895,3.4-5.032,5.863-5.543,6.325a21.265,21.265,0,0,1-6.663,4.057,23.122,23.122,0,0,1-16.319,0,21.261,21.261,0,0,1-6.662-4.057,18.992,18.992,0,0,1-4.493-6.019,17.309,17.309,0,0,1,0-14.738,18.992,18.992,0,0,1,4.493-6.019,21.264,21.264,0,0,1,6.662-4.057,23.124,23.124,0,0,1,16.319,0,21.269,21.269,0,0,1,6.663,4.057,18.989,18.989,0,0,1,4.492,6.019l1-.382V227.86a32.181,32.181,0,0,0-8.058-4.483,34.716,34.716,0,0,0-24.514,0,31.9,31.9,0,0,0-10.009,6.095,28.511,28.511,0,0,0-6.748,9.04,26,26,0,0,0,0,22.141,28.512,28.512,0,0,0,6.748,9.041,31.9,31.9,0,0,0,10.009,6.095,34.717,34.717,0,0,0,24.514,0,31.91,31.91,0,0,0,10.01-6.095c2.849-2.574,27.04-31.786,28.937-33.5a21.269,21.269,0,0,1,6.663-4.057,23.124,23.124,0,0,1,16.319,0A21.265,21.265,0,0,1,137,236.2a18.993,18.993,0,0,1,4.493,6.019,17.309,17.309,0,0,1,0,14.738A18.993,18.993,0,0,1,137,262.972a21.261,21.261,0,0,1-6.662,4.057,23.122,23.122,0,0,1-16.319,0,21.265,21.265,0,0,1-6.663-4.057,19.354,19.354,0,0,1-3.462-4.144v13.9a32.468,32.468,0,0,0,6.027,3.057,34.717,34.717,0,0,0,24.514,0,31.9,31.9,0,0,0,10.009-6.095,28.512,28.512,0,0,0,6.748-9.041,26,26,0,0,0,0-22.141Z",
    transform: "translate(-24.66 -193.61)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M122.263,279.6a29.855,29.855,0,0,1-16.919-5.206V264.044q.544.632,1.13,1.219a22.341,22.341,0,1,0,0-31.576c-.872.871-5.211,6.532-12.219,15.693-6.779,8.861-15.213,19.889-16.718,21.395a30.162,30.162,0,1,1-2.351-44.709v11.589a22.341,22.341,0,0,0-39.522,3.129,22.328,22.328,0,0,0,36.361,24.479c.376-.375,1.32-1.5,5.66-7.135,1.947-2.53,4.239-5.525,6.617-8.634l4.508-5.889c3.222-4.2,10.764-14.042,12.152-15.429a30.13,30.13,0,1,1,21.3,51.423Z",
    transform: "translate(-24.749 -193.501)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(5.957 27.428)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M114.891,228.45a22.22,22.22,0,0,1,7.612-1.77c-.494-.038-.989-.065-1.487-.07a22.4,22.4,0,0,0-16.478,6.921c-.863.9-4.245,5.514-11.722,15.784-6.015,8.262-14.206,19.512-15.55,20.908a26.273,26.273,0,0,1-8.606,5.956,26.861,26.861,0,0,1-9.244,2.138c.5.026.993.041,1.493.041a27,27,0,0,0,10.723-2.178,26.294,26.294,0,0,0,8.6-5.951c1.344-1.4,9.54-12.639,15.558-20.9,7.482-10.263,10.865-14.874,11.729-15.773A22.462,22.462,0,0,1,114.891,228.45Z",
    transform: "translate(-32.737 -221.372)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M49.731,272.111a25.269,25.269,0,0,1-7.778-5.09,25.625,25.625,0,0,1-5.49-7.6,24.864,24.864,0,0,1-2.371-9.377,23.558,23.558,0,0,1,1.4-9.434,22.528,22.528,0,0,1,4.781-7.722,22.174,22.174,0,0,1,7.425-5.182,22.66,22.66,0,0,1,7.771-1.794c-.508-.038-1.018-.065-1.531-.07a22.818,22.818,0,0,0-9.306,1.832,22.183,22.183,0,0,0-7.426,5.185,22.5,22.5,0,0,0-4.777,7.728,23.55,23.55,0,0,0-1.392,9.44,24.877,24.877,0,0,0,2.387,9.382,25.7,25.7,0,0,0,5.507,7.606,25.354,25.354,0,0,0,7.794,5.093,24.109,24.109,0,0,0,9.277,1.865c.5,0,1-.02,1.492-.05A24.106,24.106,0,0,1,49.731,272.111Z",
    transform: "translate(-31.004 -221.325)",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M66.514,223.42a29.914,29.914,0,0,1,6.319,3.762l.117,3.338a25.7,25.7,0,0,1,2.818,2.4c.1.1.2.2.3.3l-.2-6.008a29.773,29.773,0,0,0-6.306-3.758,28.558,28.558,0,0,0-11.175-2.423c-.512-.006-1.022,0-1.529.025A28.651,28.651,0,0,1,66.514,223.42Z",
    transform: "translate(-32.581 -221.031)",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M153.5,239.547a28.8,28.8,0,0,0-5.885-9.068,28.056,28.056,0,0,0-8.787-6.224,26.975,26.975,0,0,0-10.8-2.385c-.5-.007-.994,0-1.488.023a27.06,27.06,0,0,1,9.331,2.328,28.143,28.143,0,0,1,8.807,6.227,28.933,28.933,0,0,1,8.061,20.022,28.2,28.2,0,0,1-2.108,10.816,27.309,27.309,0,0,1-5.759,8.757,26.6,26.6,0,0,1-8.545,5.875,26.323,26.323,0,0,1-9.057,2.11c.482.025.966.04,1.452.04a26.512,26.512,0,0,0,19.041-8.021,27.343,27.343,0,0,0,5.763-8.751,28.186,28.186,0,0,0,2.119-10.809A28.8,28.8,0,0,0,153.5,239.547Z",
    transform: "translate(-36.833 -221.082)",
    fill: "url(#radial-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M118.891,274.982a23.489,23.489,0,0,1-5.719-3.476l.039,2.069a23.8,23.8,0,0,0,2.758,1.4,22.83,22.83,0,0,0,8.976,1.839c.487,0,.972-.02,1.455-.05A22.77,22.77,0,0,1,118.891,274.982Z",
    transform: "translate(-36.017 -224.111)",
    fill: "url(#radial-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(4.433 27.532)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M114.775,227.751a23.775,23.775,0,0,1,7.823-1.835c-.506-.032-1.013-.053-1.524-.053A23.945,23.945,0,0,0,104.1,232.9c-.9.9-4.458,5.524-12.363,15.857-6.393,8.358-15.149,19.805-16.575,21.231a28.316,28.316,0,0,1-18.587,8.288c.506.027,1.013.042,1.524.042a28.347,28.347,0,0,0,20.111-8.331c1.426-1.426,10.182-12.873,16.574-21.231,7.9-10.333,11.462-14.955,12.364-15.857A23.911,23.911,0,0,1,114.775,227.751Z",
    transform: "translate(-31.04 -221.43)",
    fill: "url(#radial-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M47.091,271.992a24,24,0,0,1,7.822-46.076c-.505-.032-1.013-.053-1.524-.053a24.009,24.009,0,1,0,0,48.018c.511,0,1.019-.022,1.524-.053A23.776,23.776,0,0,1,47.091,271.992Z",
    transform: "translate(-29.381 -221.43)",
    fill: "url(#radial-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M66.118,223.376a28.339,28.339,0,0,1,6.2,3.614v3.28a24.152,24.152,0,0,1,2.755,2.337c.1.1.2.2.292.3V226.99A28.239,28.239,0,0,0,58.1,221.142c-.511,0-1.018.015-1.524.042A28.177,28.177,0,0,1,66.118,223.376Z",
    transform: "translate(-31.04 -221.142)",
    fill: "url(#radial-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M154.619,238.514a28.416,28.416,0,0,0-26.208-17.372c-.51,0-1.018.015-1.523.042a28.439,28.439,0,0,1,0,56.8c.505.027,1.013.042,1.523.042a28.459,28.459,0,0,0,26.208-39.511Z",
    transform: "translate(-35.331 -221.142)",
    fill: "url(#radial-gradient-11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(77.845 46.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M118.175,274.759a23.853,23.853,0,0,1-5.891-3.564v2.123a23.721,23.721,0,0,0,12.189,3.329c.511,0,1.018-.022,1.524-.053A23.764,23.764,0,0,1,118.175,274.759Z",
    transform: "translate(-112.284 -271.195)",
    fill: "url(#radial-gradient-12)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup344);
export default __webpack_public_path__ + "static/media/Group 344.5625b5ea550607041183c30355be7080.svg";
export { ForwardRef as ReactComponent };